import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { matchPath, withRouter } from 'react-router-dom';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';

import styles from './styles.m.scss';

class NavDropdown extends Component {
  static propTypes = {
    as: PropTypes.any,
    baseUrl: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string,
    location: PropTypes.object,
    noIcon: PropTypes.bool,
    right: PropTypes.bool,
    title: PropTypes.string,
  };

  state = {
    isOpen: false,
  };

  toggle = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { as, baseUrl, children, className, noIcon, location, right, title } = this.props;
    const { isOpen } = this.state;
    const dropdownClasses = cn(
      'nav-link d-flex align-items-center',
      styles.dropdown,
      {
        active: matchPath(location.pathname, { path: baseUrl }),
        show: isOpen,
        'dropdown-toggle': !noIcon,
      },
      className,
    );

    return (
      <li className="nav-item dropdown">
        <button type="button" className={dropdownClasses} onClick={this.toggle}>
          {title ? title : as}
        </button>
        {isOpen && (
          <RootCloseWrapper onRootClose={this.toggle}>
            <div
              className={cn('dropdown-menu show', {
                'dropdown-menu-right': right,
              })}
              onClick={this.toggle}
            >
              {children}
            </div>
          </RootCloseWrapper>
        )}
      </li>
    );
  }
}

export default withRouter(NavDropdown);
